import React from 'react';
import { Alert } from '@economic/taco';
import { InvoicingMessage, InvoicingMessageType } from '../../invoices/book-and-send/types';

function getAlertType(messageType: InvoicingMessageType) {
    switch (messageType) {
        case InvoicingMessageType.Info:
            return 'information';
        case InvoicingMessageType.Warning:
            return 'warning';
        case InvoicingMessageType.Error:
            return 'error';
        default:
            return 'default';
    }
}

export function DisplayMessages({ messages }: { messages: InvoicingMessage[] }) {
    if (!messages) {
        return null;
    }

    messages.sort((a, b) => {
        if (a.type < b.type) return 1;
        if (a.type > b.type) return -1;
        return 0;
    });

    return (
        <ul>
            {messages
                .sort((a, b) => b.type - a.type)
                .map((message, idx) => (
                    <li key={idx} className="mt-1">
                        <div>
                            <Alert title={message.title ?? ''} state={getAlertType(message.type)}>
                                {message.message}
                            </Alert>
                        </div>
                    </li>
                ))}
        </ul>
    );
}
